/*=========================================================================================
  File Name: moduleMailServerMutations.js
  Description: MailServer Module Mutations
  ----------------------------------------------------------------------------------------
==========================================================================================*/
export default {

  SET_MAIL_SERVERS(state, payload){
    state.mailServers = payload
  },
  SET_FULL_MAIL_SERVERS(state, payload){
    state.fullmailServers = payload
  },
  SET_INFO_DB(state, payload){
    state.infoDB = payload
  },
  SET_TIME_SYNC_MAIL_SERVER(state, payload){
    state.timeSyncMailServer = payload
  }

}